import { toast } from "react-toastify";

import constants from "../../constants";
import { apiFail } from "./apiActions";

export const errorHandler = errorMessage => {
  toast.error(errorMessage, {
    position: constants.TOAST_POSITION,
  });
};

export const successHandler = successMessage => {
  toast.success(successMessage, {
    position: constants.TOAST_POSITION,
  });
};

export const catchHandler = (error, dispatch) => {
  let message = "";

  if (error?.response?.status) {
    switch (error.response.status) {
      case 404:
        message = "Not Found, Please try again";
        break;
      case 500:
        message = "Something went wrong, Please try again";
        break;
      case 403:
        message = "You are no more associated with the patient";
        break;
      case 400:
        message = error?.response?.data?.message[0] || error?.message;
        break;
      default:
        message = error?.message;
    }

    dispatch(apiFail(message));
    errorHandler(message);
  } else if (error?.response?.data) {
    dispatch(apiFail(error.response.data.message[0]));
    errorHandler(error.response.data.message[0]);
  } else {
    if (!navigator.onLine) {
      dispatch(apiFail("Network Disconnected"));
      errorHandler("Network Disconnected");
    } else {
      dispatch(apiFail("Something went wrong, Please try again"));
      errorHandler("Something went wrong, Please try again");
    }
  }
};
